import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'antd/dist/reset.css'; // For antd 5.x
import { CompatRouter } from 'react-router-dom-v5-compat';
import dayjs from 'dayjs';
import 'dayjs/locale/is';
dayjs.locale('is');

// Catch dynamic import (chunk load) errors and force a reload to get fresh assets
const handleChunkError = () => {
  const alreadyAttempted = sessionStorage.getItem('chunk_reload_attempted');
  if (!alreadyAttempted) {
    sessionStorage.setItem('chunk_reload_attempted', 'true');
    console.debug('Dynamic import failed, reloading page to get fresh assets...');
    window.location.reload();
  } else {
    console.error('Dynamic import failed again after reload. Preventing reload loop.');
  }
};

window.addEventListener('error', (e) => {
  if (
    e.message &&
    (e.message.includes('Failed to fetch dynamically imported module') ||
      e.message.includes('error loading dynamically imported module'))
  ) {
    handleChunkError();
  }
});

window.addEventListener('unhandledrejection', (e) => {
  if (
    e.reason &&
    e.reason.message &&
    (e.reason.message.includes('Failed to fetch dynamically imported module') ||
      e.reason.message.includes('error loading dynamically imported module'))
  ) {
    handleChunkError();
  }
});

// Clear the flag after 10 seconds of successful operation
setTimeout(() => {
  sessionStorage.removeItem('chunk_reload_attempted');
}, 10000);

ReactDOM.render(
  <Router>
    <CompatRouter>
      <App />
    </CompatRouter>
  </Router>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
